import { useAppShell } from "../AppShellContext";
import MobileFeed from "./MobileFeed";
import MobileChattr from "./MobileChattr";
import MentorsPage from "../../components/MentorsPage";

const TABS = [
  { id: "feed",    emoji: "📰", label: "Feed" },
  { id: "chattr",  emoji: "💬", label: "Chattr" },
  { id: "mentors", emoji: "📅", label: "Mentors" },
];

export default function ConnectScreen() {
  // ✅ Removed useState("feed") and replaced with context variables
  const { connectTab, setConnectTab } = useAppShell();
  const activeTab = connectTab || "feed"; // Fallback safety

  return (
    <div className="hh-connect">
      <div className="hh-connect-tabs">
        {TABS.map(t => (
          <button key={t.id}
            className={`hh-connect-tab${activeTab === t.id ? " active" : ""}`}
            onClick={() => setConnectTab(t.id)}>
            {t.emoji} {t.label}
          </button>
        ))}
      </div>

      <div className="hh-connect-content">
        {activeTab === "feed" && <MobileFeed />}
        {activeTab === "chattr" && <MobileChattr />}
        {activeTab === "mentors" && (
          <div className="hh-connect-section">
            <div className="hh-connect-component-wrap">
              <MentorsPage />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}